const ADASLDWS: { [key: string]: string } = {
  "1": "50km/h",
  "2": "60km/h",
  "3": "70km/h",
};

export default ADASLDWS;
